(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4087,5945],{

/***/ 5298:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/studio",
      function () {
        return __webpack_require__(28914);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11717);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39953);
/* harmony import */ var _components_characters_CharacterCardList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38662);
/* harmony import */ var _components_common_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30208);
/* harmony import */ var _components_common_Tab__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93127);
/* harmony import */ var _components_community_PostList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(959);
/* harmony import */ var _components_layout_Header__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58761);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26382);
/* harmony import */ var _components_layout_SafeArea__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45861);
/* harmony import */ var _components_stories_StoryList__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94942);
/* harmony import */ var _components_user_UserInfo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27425);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39854);
/* harmony import */ var _contexts_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71727);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30259);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97033);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45874);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81946);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















var containerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)(_templateObject());
var MyPageDetail = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var web = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_17__/* .useWebView */ .B9)().web;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_14__/* .useGlobalContext */ .bN)(), platform = ref.platform, version = ref.version, isCheming = ref.isCheming;
    var ref1 = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_15__/* .useMe */ .Pi)(), user = ref1.data;
    var userId = user && user.id || 0;
    (0,_utils_hook__WEBPACK_IMPORTED_MODULE_15__/* .useScreen */ .EV)("마이페이지");
    var tabs = (0,_components_common_Tab__WEBPACK_IMPORTED_MODULE_5__/* .useTab */ .x)([
        {
            label: t("작품"),
            value: "stories"
        },
        {
            label: t("플레이"),
            value: "play"
        },
        {
            label: t("커뮤니티"),
            value: "community"
        }, 
    ], {
        replace: true
    });
    var activeTab = tabs.activeTab;
    if (!user) {
        return null;
    }
    var handleNavigateVouchers = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_12__/* .Platform.web */ .t4.web) {
            router.push("/vouchers");
        }
        web.openPage("/vouchers");
    };
    var handleNavigateSetting = function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_12__/* .Platform.web */ .t4.web) {
            router.push("/setting");
        }
        if ((0,_utils_misc__WEBPACK_IMPORTED_MODULE_16__/* .checkRequiredAppVersion */ ._h)(platform, version, {
            iOS: "2.25.1",
            android: "2.31.1"
        })) {
            web.openPage("/setting");
        } else {
            web.openSetting();
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_layout_Header__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: "마이페이지",
                left: function() {
                    if (isCheming) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {});
                    }
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                        onClick: handleNavigateVouchers,
                        children: "쿠폰함"
                    });
                },
                right: function() {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
                        onClick: handleNavigateSetting,
                        children: "설정"
                    });
                },
                hideBackButton: true
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_user_UserInfo__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                userId: userId,
                isMyPage: true,
                balloon: true,
                subscription: true
            }),
            !isCheming && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Tab__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({}, tabs), {
                fit: true
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                fallback: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    push: true
                }),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("div", {
                    css: containerCSS,
                    children: [
                        isCheming && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_characters_CharacterCardList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            userId: userId,
                            isMyPage: true
                        }),
                        activeTab === "stories" && !isCheming && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_stories_StoryList__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            userId: userId,
                            isMyPage: true
                        }),
                        activeTab === "play" && !isCheming && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_characters_CharacterCardList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            userId: userId,
                            isMyPage: true
                        }),
                        activeTab === "community" && !isCheming && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_community_PostList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            userId: userId,
                            isMyPage: true
                        })
                    ]
                })
            })
        ]
    });
};
var MyPage = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        isPush: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
            fallback: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_common_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                center: true
            }),
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_layout_SafeArea__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                bottom: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(MyPageDetail, {})
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_contexts_auth__WEBPACK_IMPORTED_MODULE_13__/* .withAuth */ .QO)(MyPage, {
    isSignInRequired: true
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1425,496,5277,308,2127,6966,3127,6683,1385,2529,6538,6117,5589,6861,231,9774,2888,179], function() { return __webpack_exec__(5298); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);